"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "overlays", {
  enumerable: true,
  get: function get() {
    return _overlays["default"];
  }
});
var _overlays = _interopRequireDefault(require("./overlays"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }